const vn = {
    inv: 'hàng tồn kho',
    trade: 'buôn bán',
    transfer: 'chuyển khoản',
    temporary: 'tạm thời',
    inbound: 'Kho',
    outbound: 'hết kho',
    scanOrder: 'thứ tự quét',
    inputOrder: 'bảng đầu vào',
    beConfirmed: 'được xác nhận',
    confirmed: 'đã xác nhận',
    invInProgress: 'Đang tồn kho',
    genertDifferences: 'Tạo ra sự khác biệt',
    cpletDifIn: 'Hoàn thành việc lưu trữ chênh lệch',
    cpletDifOut: 'Hoàn thành phân phối khác biệt',
    cplet: 'hoàn thành',
    inboundSuccess: 'Nhập kho thành công',
    outboundSuccess: 'Kho thành công',
    conIn: 'Xác định thư viện',
    conOut: 'Xác định thư viện',
    perOutbound: 'Thư viện tiền xuất',
    normalType: "Vật liệu thông thường",
    completeType: "Thành phẩm",
    wastedType: "Vật liệu phế thải",
    tempType: "Vị trí tạm thời (trung chuyển)",
    locationType: "Loại vị trí kho",
    outter: "Vị trí bên ngoài/Vị trí nước ngoài",
    productionType: "của xưởng sản xuất",
    defectiveReturnType: "Không đạt, cần trả hàng",
    defectiveTempType: "Không đạt, lưu tạm",
    locLocked: "Vị trí đang bị khóa/kiểm kê",
    preOutExsist: "Vị trí có xuất kho dự kiến",
    locNull: "Vị trí không tồn tại",
    proQtyFalse: "Số lượng sản phẩm không khớp",
    calcErr: "Lỗi tính vị trí đơn hàng",
    list: "Lịch sử",
    batchAdd: "Nhập kho",
    adjust: "Xuất kho",
    count: "Kiểm kê",
    batchNo: "Số lô",
    opType: "Loại thao tác",
    beforeCount: "Số lượng trước thay đổi",
    changeCount: "Số lượng thay đổi",
    afterCount: "Số lượng sau thay đổi",
    createdAt: "Thời gian tạo",
    inventoryType: "Loại nhập/xuất",
};

export default vn;
